import { render, staticRenderFns } from "./GiftCardReg.vue?vue&type=template&id=5d3ec2f1&"
import script from "./GiftCardReg.vue?vue&type=script&lang=js&"
export * from "./GiftCardReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports